import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  { value: "fast", labelKey: "fast" },
  { value: "moderate", labelKey: "moderate", descKey: "moderateDesc" },
  { value: "slow", labelKey: "slow" },
] as const

export default function SpeedGoal() {
  return <SingleSelectPage translationKey="speedGoal" options={OPTIONS} />
}
